import { render } from "./Holidays.vue?vue&type=template&id=f2240178&scoped=true"
import script from "./Holidays.vue?vue&type=script&lang=js"
export * from "./Holidays.vue?vue&type=script&lang=js"

import "./Holidays.vue?vue&type=style&index=0&id=f2240178&scoped=true&lang=css"
import "./Holidays.vue?vue&type=style&index=1&id=f2240178&lang=css"
import "@/assets/css/hr-page-shared.css?vue&type=style&index=2&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2240178"]])

export default __exports__